import React, { useState, useEffect } from 'react';

export function CalendarDays(props) {
  const [days, setDays] = useState([]);
  const { calendar, date, update } = props;

  const handleDaySelect = (day) => {
    update({ day: day });
  };
  useEffect(() => {
    // console.log('Days, Date', date);
    const { months } = calendar;
    const activeMonth = months[parseInt(date.month, 10)];
    let day = parseInt(date.day, 10);
    const isLeapYear = parseInt(date.year, 10) % activeMonth.leapPeriod === 0;
    const maxDays = isLeapYear
      ? activeMonth.days + activeMonth.leapDays
      : activeMonth.days;
    if (day > maxDays) day = maxDays;
    let dayItems = [];
    for (let i = 0; i < maxDays; i++) {
      dayItems.push(
        <CalendarDay
          day={i + 1}
          active={i + 1 === day}
          key={i + 1}
          selectDay={handleDaySelect}
        />
      );
    }
    setDays(dayItems);
  }, [date]);

  return (
    <div className="chronos-calendar-date-picker-days">
      <div className="calendar-days-list">{days}</div>
    </div>
  );
}

function CalendarDay({ day, selectDay, active }) {
  const classes = ['chronos-calendar-day'];
  if (active) {
    classes.push('chronos-calendar-day-active');
  }
  const handleDaySelect = () => {
    selectDay(day - 0);
  };
  return (
    <div className={classes.join(' ')} onClick={handleDaySelect}>
      {day}
    </div>
  );
}
